// extracted by mini-css-extract-plugin
export var withoutText = "logoSite-module--withoutText--5bee1";
export var wrapper = "logoSite-module--wrapper--ed4f0";